import Logger from '../functions/logging';

export default class ApiError {
	constructor(error) {
		// Logger.log("ApiError", "ApiError()", JSON.stringify(error));

		this.error = error;
		this.name = error.name ? error.name : null;
		this.message = error.message ? error.message : null;
		this.status = error.status ? error.status : null;
		this.statusText = error.statusText ? error.statusText : null;

		if (error.response) {
			// Server responded with a status code that falls out of the range of 2xx
			// Logger.log(this.constructor.name, "ApiError() error response", error.response);

			// Sample response:
			// "response": {
			// 		"data": {
			// 			"error": {
			// 				"success":false,
			// 				"foo":"user_id_incorrect",
			// 				"user_id_param":"us-east-1:c472f9f1-a011-4072-a9cf-c03e766481c6"
			// 			}
			// 		}
			// 		"status": 400,
			// 		"statusText": "Bad Request",
			// 		"headers": {},
			// 		"config": {},
			// 		"request": {}	  
			// }
			this.error = error.response;
			this.status = error.response.status ? error.response.status : this.status;
			this.statusText = error.response.statusText ? error.response.statusText : this.statusText;
			if (error.response.data && error.response.data.error) {
				const { data } = error.response;
				if (typeof data.error === "string") {
					this.code = data.error;
				}
				else {
					this.data = data.error;
					if (data.error.code) {
						this.code = data.error.code;
					}
				}
			}
		} else if (error.request) {
			// Logger.log(this.constructor.name, "ApiError() error request", error.request);
			this.error = error.request;
			this.message = "The request was made but no response was received.";
		} else if (error.message) {
			// Something happened in setting up the request that triggered an Error
			// Logger.log(this.constructor.name, "ApiError() error default", error.message);
			this.error = error.message;
		}

		// Logger.log("ApiError", "ApiError() this.error", this.error);
	}

	// // Getter
	// get area() {
	// 	return this.calcArea();
	// }

	// // Method
	// calcArea() {
	// 	return this.height * this.width;
	// }
}


// WEBPACK FOOTER //
// ./src/api/apiError.js